import { Component, Input } from '@angular/core';
import { TvIcon } from '../icon/icon.enum';

@Component({
    selector: 'tvcore-message',
    templateUrl: './message.component.html',
    styleUrls: ['./message.component.scss'],
    standalone: false
})
export class MessageComponent {
	@Input()
	icon: TvIcon | string;
	@Input()
	color: 'grey' | 'green' | 'orange' | 'red' | 'blue' = 'grey';
	@Input()
	sm: boolean = false;
}
